import { ValidationLevel } from 'ui';
import { AccessPanelData, AccessPanelDataValidation, AccessItem } from 'app/components/access-panel/shared/types';

export const accessDataValidation = (accessData: AccessPanelData, message: string): AccessPanelDataValidation => {

  const result = Object.keys(accessData)
    .map(propertyKey => {
      const value: AccessItem = accessData[propertyKey];
      const customData = value && value.customData || {};

      const { selectedOptions = [], selectedValues = [] } = customData;

      const filteredSelectedValues: string[] = Object.keys(selectedValues).filter(key => selectedValues[key]);

      const applicationIds: string[] = selectedOptions
        .map(option => String(option.value))
        .filter(option => !filteredSelectedValues.includes(option));

      return applicationIds && applicationIds.length > 0
        ? {
          [propertyKey]: {
            level: ValidationLevel.error,
            messages: applicationIds.map(id => {
              return {
                level: ValidationLevel.error,
                message,
                parameters: {
                  application: parseInt(id, 10)
                }
              };
            })
          }
        } : {};
    })
    .filter(f => !!f)
    .reduce((acc, curr) => {
      return { ...acc, ...curr };
    }, {});

  return !!Object.keys(result).length ? result : undefined;
};
